import { render, staticRenderFns } from "./DataListTeams.vue?vue&type=template&id=12efbcfb&scoped=true&"
import script from "./DataListTeams.vue?vue&type=script&lang=js&"
export * from "./DataListTeams.vue?vue&type=script&lang=js&"
import style0 from "./DataListTeams.vue?vue&type=style&index=0&id=12efbcfb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12efbcfb",
  null
  
)

export default component.exports